<template>
  <v-row v-if="loaded">
    <v-col cols="12">
      <div class="Mh--100 white">
        <registration-form
          :validationErr="validationErr"
          :freezer="freezer"
          :formData="form"
          ref="registr"
        >
          <div class="mt-3">
            <v-btn @click="submit()" class="ma-1" dark color="primary">
              تایید و ثبت نهایی</v-btn
            >
            <v-btn @click="logOut()" :disabled="disablesBtn" class="ma-1"
              >خروج</v-btn
            >
          </div>
        </registration-form>
      </div>
    </v-col>
    <v-dialog
      v-model="showFinalDialog"
      v-if="showFinalDialog"
      persistent
      max-width="550"
    >
      <v-card>
        <v-toolbar color="mineBoxBarColor" dark>
          <div class="d-flex justify-space-between align-center w--100">
            <div>کاربرگرامی</div>
            <div class="font-s">
              {{ timer }} <v-icon class="mdi mdi-timer"></v-icon>
            </div>
          </div>
        </v-toolbar>
        <v-card-text>
          <div class="d-flex flex-column justify-start align-start pa-2 my-2">
            <h4 class="h4">شما تا چند لحظه دیگر وارد پنل کاربری می شوید.</h4>
            <h4 class="h4">در این پنل شما به موارد زیر دسترسی دارید:</h4>
            <ul>
              <li>تکمیل اطلاعات بیشتری از کسب و کار</li>
              <li>مشاهده و ویرایش اطلاعات ثبت شده در این مرحله</li>
              <li>بارگزاری مدارک مورد نیاز برای تکمیل اطلاعات کسب و کار شما</li>
              <li>امکان نمایش پیام های مدیریت تکصان</li>
              <!-- <li>پس از بررسی و تکمیل اطلاعات می توانید  درخواست بررسی ثبت کنید</li> -->
            </ul>
          </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn
            :disabled="timer >= 20"
            color="orange accent-4"
            class="white--text"
            @click="navTo()"
            ><span>همین الان</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import registrationForm from '../components/registrationForm.vue';
import reusableMethodsMixin from '../../../core/mixins/reusableMethodsMixin';
import { mapActions, mapGetters } from 'vuex';
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
import Swal from 'sweetalert2';
const authRepository = () => RepoFactory.get('auth');
const supplierRepository = () => RepoFactory.get('supplier');

function beforeunloadFunc(e) {
  console.log(e);
  var confirmationMessage = 'آیا میخواهید صفحه را ترک کنید؟ ';

  (e || window.event).returnValue = confirmationMessage;
}
export default {
  name: 'consumer-registration',
  components: { registrationForm },
  mixins: [reusableMethodsMixin],
  data() {
    return {
      validationErr: null,
      flag: false,
      loading: false,
      freezer: false,
      loaded: false,
      step: 1,
      disablesBtn: false,
      timer: 25,
      showFinalDialog: false,
      form: {
        categoryTypes: [],
        name: null,
        about: null,
        logoFileId: null,
        backgroundImage: null,
        imagesFileIds: null,
        company: {
          name: null,
          brandName: null,
          nationalId: null,
          registrarNumber: null,
          economicCode: null,
          taxCode: null,
          companyType: null,
          isic: null,
          guildId: null,
        },
        address: {
          title: 'آدرس ثبت شده در فرایند ثبت نام',
          cityId: '126',
          neighbourhoodId: null,
          addressLane: null,
          postalCode: null,
          no: null,
          unit: null,
          latitude: null,
          longitude: null,
        },

        phones: [
          {
            title: 'کار',
            type: 'Work',
            phoneNumber: null,
          },
          {
            title: 'همراه',
            type: 'Mobile',
            phoneNumber: null,
          },
        ],
        businessDocumentNumber: null,
        email: null,
        website: null,
        permittedSignerNames: null,
        creatorPerson: {
          firstName: null,
          lastName: null,
          gender: 'Male',
          birthdate: null,
          nationalCode: null,
          memberType: null,
        },
        managerPerson: {
          firstName: null,
          lastName: null,
          gender: 'Male',
          birthdate: null,
          nationalCode: null,
          memberType: 'Manager',
          mobile: '',
        },
        categoryIds: [],
        creatorIsManager: true,
        isManufacturer: null,
        yearOfFoundation: null,
        numberOfEmployee: null,
      },
    };
  },
  computed: {
    ...mapGetters(['merchantBaseUrl']),
  },
  methods: {
    ...mapActions('oidc', ['signOutOidc', 'authenticateOidc']),
    logOut() {
      this.signOutOidc();
    },

    async submit() {
      let app = this;
      const check = await this.$refs.registr.$refs.obs.validate();
      if (!check) {
        let err = {
          response: { data: this.$refs.registr.$refs.obs.errors, status: 400 },
          receive: 'front',
        };
        return Helper.handleErrors(err, this);
      }

      // if (!this.form.categoryIds.length) {
      //   return Swal.fire({
      //     icon: 'error',
      //     title: 'خطا',
      //     html: 'شما هیچ کسب و کاری انتخاب نکرده اید',
      //     confirmButtonText: ' بستن',
      //   });
      // }

      // const clonedFormData = JSON.parse(JSON.stringify(this.form));
      const clonedFormData = this.form;

      if (!clonedFormData.name) {
        clonedFormData.name = clonedFormData.company.name;
      }
      if (!clonedFormData.company.name) {
        clonedFormData.company.name = clonedFormData.name;
      }
      if (clonedFormData.creatorIsManager) {
        clonedFormData.creatorPerson = null;
      }

      this.disablesBtn = true;
      const loader = this.$loading.show();
      this.pruneProperties(this.form);
      supplierRepository()
        .createSupplierAsConsumer(clonedFormData, this.merchantBaseUrl)
        .then(() => {
          this.showFinalDialog = true;
          window.removeEventListener('beforeunload', beforeunloadFunc);
          setInterval(() => {
            if (this.timer > 0) {
              this.timer -= 1;
            }
          }, 1000);
          setTimeout(() => {
            this.authenticateOidc();
          }, 25000);
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);

          // app.validationErr = error.response.data.validationErrors[0];
          loader.hide();
          // this.disablesBtn = false;
        });
    },
    navTo() {
      this.flag = true;
      window.removeEventListener('beforeunload', beforeunloadFunc);
      this.authenticateOidc();
    },
    async getData() {
      const { data } = await authRepository().getUserDetail(
        this.$store.getters.authBaseUrl
      );
      this.form.phones[1].phoneNumber = '0' + data.phone;
      this.form.phones[0].phoneNumber = '0' + data.phone;
      this.form.managerPerson.firstName = data.firstName;
      this.form.managerPerson.lastName = data.lastName;
      this.form.managerPerson.birthdate = data.birthdate;
      this.form.managerPerson.gender = data.gender;
      this.form.managerPerson.nationalCode = data.nationalCode;
      this.form.managerPerson.mobile = '0' + data.phone;

      this.form.creatorPerson.firstName = data.firstName;
      this.form.creatorPerson.lastName = data.lastName;
      this.form.creatorPerson.birthdate = data.birthdate;
      this.form.creatorPerson.gender = data.gender;
      this.form.creatorPerson.nationalCode = data.nationalCode;
    },
  },
  mounted() {
    this.getData();
    this.loaded = true;

    if (
      this.$route.query.isManufacturer &&
      ['true', 'false'].includes(this.$route.query.isManufacturer)
    ) {
      if (this.$route.query.isManufacturer == 'true') {
        this.form.isManufacturer = true;
      } else {
        this.form.isManufacturer = false;
      }
    }
    if (this.flag == false) {
      window.addEventListener('beforeunload', beforeunloadFunc);
      history.pushState(null, document.title, location.href);
      window.addEventListener('popstate', function (event) {
        const leavePage = confirm('آیا میخواهید صفحه را ترک کنید؟ ');
        if (leavePage) {
          history.back();
        } else {
          history.pushState(null, document.title, location.href);
        }
      });
    }
  },
};
</script>

<style scoped>
span {
  font-family: '';
}
.bgc {
  background-color: #5b6a89 !important;
}
.side {
  background-color: #e9eaeb;
  border-bottom-left-radius: 150px;
  height: 90vh;
  width: 550px;
  padding: 40px;
}
.side_mobile {
  width: 100%;
  background-color: #e9eaeb;
}
.roud {
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: start;
  margin-top: 30px;
}
.roud_mobile {
  width: 90%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;
  align-items: start;
  margin-top: 30px;
}
.Mh--100 {
  max-height: 90vh;
  overflow-y: auto;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none;
}
.Mh--100::-webkit-scrollbar {
  /* WebKit */
  width: 10px;
  height: 0;
}
.fix {
  background-color: #5b6a89;
  position: fixed;
  bottom: 0px;
  margin: auto;
}
.font-s {
  font-size: 20px;
}
</style>
